<template>
    <v-container fluid>
        <v-row v-if="contractEdit == false" dense>
            <v-col cols="12">
                <v-tabs left v-model="tabMain">
                    <v-tab
                        @click.native.prevent="changeTab('placement-information')"
                        key="placement-information"
                        href="#placement-information"
                    >
                        {{ $t('tabs.placementInformation') }}
                    </v-tab>
                    <v-tab
                        v-if="placement.id != 0"
                        @click.native.prevent="changeTab('document-checklist')"
                        key="document-checklist"
                        href="#document-checklist"
                    >
                        {{ $t('tabs.documentChecklist') }}
                    </v-tab>
                    <v-tab
                        v-if="placement.id != 0"
                        @click.native.prevent="changeTab('contracts')"
                        key="contracts"
                        href="#contracts"
                    >
                        {{ $t('tabs.contracts') }}
                    </v-tab>
                    <v-tab
                        v-if="placement.id != 0"
                        @click.native.prevent="changeTab('expenses')"
                        key="expenses"
                        href="#expenses"
                    >
                        {{ $t('tabs.expenses') }}
                    </v-tab>
                    <v-tab
                        v-if="
                            (placement.id != 0 && placement.placement_status_id == 9) ||
                            placement.placement_status_id == 8
                        "
                        @click.native.prevent="changeTab('salary')"
                        key="salary"
                        href="#salary"
                    >
                        {{ $t('tabs.salary') }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                        key="placement-information"
                        value="placement-information"
                        style="
                            margin-top: 3px;
                            margin-bottom: 0px;
                            scroll-margin: 0px;
                            height: 83vh;
                            overflow-y: scroll;
                            overflow-x: hidden;
                        "
                    >
                        <v-row>
                            <v-col class="pl-5">
                                <v-btn
                                    v-if="inEditMode && placement.id != 0"
                                    class="ml-2 mr-2"
                                    color="primary"
                                    @click="saveClick(false)"
                                >
                                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                                </v-btn>
                                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                                </v-btn>
                                <v-btn
                                    v-if="!inEditMode && !placement.gdpr_edit_lock"
                                    class="ml-2 mr-2"
                                    color="primary"
                                    @click="editClick()"
                                >
                                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                                </v-btn>
                                <v-btn class="mr-2" @click="backClick">
                                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                                </v-btn>
                            </v-col>
                            <v-col class="text-right">
                                <v-btn
                                    v-if="
                                        inEditMode &&
                                        placement.id != 0 &&
                                        placement.placement_status_id == 2 &&
                                        !placement.gdpr_edit_lock
                                    "
                                    class="ml-2 mr-2"
                                    color="primary"
                                    @click="cancelPlacement(null)"
                                >
                                    <v-icon small>fas fa-ban</v-icon>&nbsp;{{ $t('buttons.cancelPlacement') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" xl="6" lg="6" md="6">
                                <v-card flat>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="2" v-if="placement.id != 0">
                                                <InputField
                                                    :readonly="true"
                                                    v-model="placement.id"
                                                    :label="$t('fields.id')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="10" v-if="placement.id != 0"> </v-col>
                                            <v-col cols="12" v-if="placement.id == 0">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="placement.vacancy_id"
                                                    :ajax="true"
                                                    :data="'vacancies'"
                                                    :errorBorder="!placementValidation.vacancy_id"
                                                    :label="$t('fields.assignToVacancy')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="11">
                                                <Dropdown
                                                    :readonly="placement.id != 0"
                                                    v-model="placement.seafarer_id"
                                                    :ajax="true"
                                                    :data="'seafarers-for-placement'"
                                                    :errorBorder="!placementValidation.seafarer_id"
                                                    :label="'* ' + $t('fields.seafarer')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="1" v-if="placement.seafarer_id != null">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn
                                                            color="primary"
                                                            icon
                                                            v-bind="attrs"
                                                            @click="openSeafarer()"
                                                            v-on="on"
                                                        >
                                                            <v-icon small>fas fa-link</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('tooltips.openSeafarer') }}</span>
                                                </v-tooltip>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="maritimeObjectReadOnly"
                                                    v-model="placement.maritime_object_id"
                                                    :ajax="true"
                                                    :data="'maritime-objects'"
                                                    :errorBorder="!placementValidation.maritime_object_id"
                                                    :label="'* ' + $t('fields.maritimeObject')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <Dropdown
                                                    :readonly="rankReadOnly"
                                                    v-model="placement.rank_id"
                                                    :ajax="true"
                                                    :data="'ranks'"
                                                    :errorBorder="!placementValidation.rank_id"
                                                    :label="'* ' + $t('fields.rank')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="6">
                                                <Dropdown
                                                    :readonly="!inEditMode"
                                                    v-model="placement.seniority"
                                                    :ajax="false"
                                                    :data="seniorityList"
                                                    :errorBorder="!placementValidation.seniority"
                                                    :label="$t('fields.seniority')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="20"
                                                    v-model="placement.po_number"
                                                    :errorBorder="!placementValidation.po_number"
                                                    :label="$t('fields.poNumber')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="6"></v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" xl="6" lg="6" md="6">
                                <v-card flat>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12" v-if="placement.id == 0">
                                                <Dropdown
                                                    :readonly="true"
                                                    v-model="placement.placement_status_id"
                                                    :ajax="true"
                                                    :data="'placement-statuses'"
                                                    :errorBorder="!placementValidation.placement_status_id"
                                                    :label="'* ' + $t('fields.status')"
                                                ></Dropdown>
                                            </v-col>
                                            <v-col cols="12" v-else>
                                                <v-layout>
                                                    <div class="text-h6">{{ $t('labels.placementStatus') }} :</div>
                                                    <v-icon :color="colorForStatus" small class="mr-2 ml-10"
                                                        >fas fa-circle</v-icon
                                                    >

                                                    <div class="font-weight-bold text-h6">
                                                        {{ statusDisplay }}
                                                    </div>
                                                </v-layout>
                                                <v-layout>
                                                    <div class="text-h6">{{ $t('labels.seafarerStatus') }} :</div>
                                                    <div class="font-weight-bold text-h6 ml-10">
                                                        {{ seafarerStatusDisplay }}
                                                    </div>
                                                </v-layout>
                                            </v-col>
                                            <v-col cols="12">
                                                <TextArea
                                                    :readonly="!inEditMode"
                                                    :maxlength="1000"
                                                    v-model="placement.status_notes"
                                                    :errorBorder="!placementValidation.status_notes"
                                                    :label="$t('fields.notes')"
                                                ></TextArea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.relevantDates') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <DatePicker
                                                    :readonly="!inEditMode"
                                                    v-model="placement.sign_on_date"
                                                    :errorBorder="!placementValidation.sign_on_date"
                                                    :date-label="'* ' + $t('fields.signOnPlanned')"
                                                ></DatePicker>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.travelArrangements') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="12">
                                                <InputField
                                                    :readonly="!inEditMode"
                                                    :maxlength="10"
                                                    v-model="placement.flight_reservation"
                                                    :errorBorder="!placementValidation.flight_reservation"
                                                    :label="$t('fields.flightReservation')"
                                                ></InputField>
                                            </v-col>
                                            <v-col cols="12">
                                                <TextArea
                                                    :readonly="!inEditMode"
                                                    :maxlength="500"
                                                    v-model="placement.travel_info"
                                                    :errorBorder="!placementValidation.travel_info"
                                                    :label="$t('fields.travelInfo')"
                                                ></TextArea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="8" v-if="placement.id != 0">
                                <v-card flat outlined>
                                    <v-card-title>
                                        {{ $t('labels.notes') }}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row>
                                            <v-col>
                                                <v-data-table
                                                    :items="notesList"
                                                    fixed-header
                                                    dense
                                                    class="row-item"
                                                    :items-per-page="-1"
                                                    :hide-default-header="true"
                                                    :hide-default-footer="true"
                                                    :height="200"
                                                    :no-data-text="''"
                                                >
                                                    <template v-slot:item="row">
                                                        <tr>
                                                            <td>
                                                                <v-row dense>
                                                                    <v-col cols="2">
                                                                        {{ row.item.userData }} <br />
                                                                        {{ row.item.timestampdata }}
                                                                    </v-col>
                                                                    <v-col cols="10">
                                                                        <TextArea
                                                                            :readonly="true"
                                                                            v-model="row.item.note"
                                                                            :height="50"
                                                                        ></TextArea></v-col
                                                                ></v-row>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-slot:footer v-if="inEditMode">
                                                        <v-row dense>
                                                            <v-col cols="10">
                                                                <TextArea
                                                                    :readonly="!inEditMode"
                                                                    :maxlength="500"
                                                                    v-model="note.note"
                                                                    :label="$t('fields.notes')"
                                                                ></TextArea>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <v-btn
                                                                    class="ml-2 mr-2"
                                                                    color="primary"
                                                                    @click="saveNote()"
                                                                >
                                                                    <v-icon small>fa-save</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" v-if="agreedSalaries">
                                <v-card flat>
                                    <v-card-title>
                                        {{ $t('labels.agreedSalaries') }}
                                    </v-card-title>
                                </v-card>
                            </v-col>
                            <v-col cols="6" v-if="agreedSalaries && activeAgreedSalary != null">
                                <v-card flat outlined color="#81C784" shaped>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="5">
                                                <v-row dense wrap>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.contract_id"
                                                            :label="$t('fields.contractId')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <Dropdown
                                                            :readonly="true"
                                                            v-model="activeAgreedSalary.rank_id"
                                                            :ajax="true"
                                                            :data="'ranks'"
                                                            :label="$t('fields.rank')"
                                                        ></Dropdown>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            v-model="activeAgreedSalary.seniority"
                                                            :label="$t('fields.seniority')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <DatePicker
                                                            :readonly="true"
                                                            v-model="activeAgreedSalary.effective_from"
                                                            :date-label="$t('fields.effectiveFrom')"
                                                        ></DatePicker>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <DatePicker
                                                            :readonly="true"
                                                            v-model="activeAgreedSalary.effective_to"
                                                            :date-label="$t('fields.effectiveTo')"
                                                        ></DatePicker>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="2"></v-col>
                                            <v-col cols="5">
                                                <v-row dense wrap>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.full"
                                                            :label="$t('fields.fullDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.sick"
                                                            :label="$t('fields.sickDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.travel"
                                                            :label="$t('fields.travelDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.training"
                                                            :label="$t('fields.trainingDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.quarantine"
                                                            :label="$t('fields.quarantineDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.standby"
                                                            :label="$t('fields.standbyDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="activeAgreedSalary.other"
                                                            :label="$t('fields.otherDay')"
                                                        ></InputField>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="6" v-if="agreedSalaries && pastAgreedSalary != null">
                                <v-card flat outlined color="#BDBDBD" shaped>
                                    <v-card-text>
                                        <v-row dense wrap>
                                            <v-col cols="5">
                                                <v-row dense wrap>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.contract_id"
                                                            :label="$t('fields.contractId')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <Dropdown
                                                            :readonly="true"
                                                            v-model="pastAgreedSalary.rank_id"
                                                            :ajax="true"
                                                            :data="'ranks'"
                                                            :label="$t('fields.rank')"
                                                        ></Dropdown>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            v-model="pastAgreedSalary.seniority"
                                                            :label="$t('fields.seniority')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <DatePicker
                                                            :readonly="true"
                                                            v-model="pastAgreedSalary.effective_from"
                                                            :date-label="$t('fields.effectiveFrom')"
                                                        ></DatePicker>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <DatePicker
                                                            :readonly="true"
                                                            v-model="pastAgreedSalary.effective_to"
                                                            :date-label="$t('fields.effectiveTo')"
                                                        ></DatePicker>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="2"></v-col>
                                            <v-col cols="5">
                                                <v-row dense wrap>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.full"
                                                            :label="$t('fields.fullDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.sick"
                                                            :label="$t('fields.sickDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.travel"
                                                            :label="$t('fields.travelDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.training"
                                                            :label="$t('fields.trainingDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.quarantine"
                                                            :label="$t('fields.quarantineDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.standby"
                                                            :label="$t('fields.standbyDay')"
                                                        ></InputField>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <InputField
                                                            :readonly="true"
                                                            :maxlength="50"
                                                            v-model="pastAgreedSalary.other"
                                                            :label="$t('fields.otherDay')"
                                                        ></InputField>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                        key="document-checklist"
                        value="document-checklist"
                        style="
                            margin-top: 3px;
                            margin-bottom: 0px;
                            scroll-margin: 0px;
                            height: 92vh;
                            overflow-y: scroll;
                            overflow-x: hidden;
                        "
                    >
                        <PlacementDocumentChecklistVue
                            @edit="editForTab()"
                            :inEditMode="inEditMode"
                            :placement="placement"
                        ></PlacementDocumentChecklistVue>
                    </v-tab-item>
                    <v-tab-item
                        key="contracts"
                        value="contracts"
                        style="
                            margin-top: 3px;
                            margin-bottom: 0px;
                            scroll-margin: 0px;
                            height: 92vh;
                            overflow-y: scroll;
                            overflow-x: hidden;
                        "
                    >
                        <PlacementContracts
                            :inEditMode="inEditMode"
                            @edit="editForTab()"
                            @remove-edit="removeEdit()"
                            :placement="placement"
                            @reload="reloadPlacement"
                        ></PlacementContracts>
                    </v-tab-item>
                    <v-tab-item
                        key="expenses"
                        value="expenses"
                        style="
                            margin-top: 3px;
                            margin-bottom: 0px;
                            scroll-margin: 0px;
                            height: 92vh;
                            overflow-y: scroll;
                            overflow-x: hidden;
                        "
                    >
                        <PlacementExpensesVue
                            @edit="editForTab()"
                            :inEditMode="inEditMode"
                            :placement="placement"
                        ></PlacementExpensesVue>
                    </v-tab-item>
                    <v-tab-item
                        key="salary"
                        value="salary"
                        style="
                            margin-top: 3px;
                            margin-bottom: 0px;
                            scroll-margin: 0px;
                            height: 92vh;
                            overflow-y: scroll;
                            overflow-x: hidden;
                        "
                    >
                        <PlacementSalary
                            @edit="editForTab()"
                            :inEditMode="inEditMode"
                            :placement="placement"
                        ></PlacementSalary>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PlacementSeaContract
                    @close-edit="closeContract"
                    :currentContract="currentContract"
                    :contractEdit="contractEdit"
                    :placement="placement"
                ></PlacementSeaContract>
            </v-col>
            <v-col cols="12">
                <PlacementNorwegianContractVue
                    @close-edit="closeContract"
                    :currentContract="currentContract"
                    :contractEdit="contractEdit"
                    :placement="placement"
                ></PlacementNorwegianContractVue>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import InputField from './trinkets/InputField';
import Dropdown from './trinkets/Dropdown';
import Placement from '../models/Placement';
import PlacementNote from '../models/PlacementNote';
import DatePicker from '@/components/trinkets/DatePicker';
import TextArea from '@/components/trinkets/TextArea';
import PlacementContracts from './PlacementContracts.vue';
import AgreedSalary from '../models/AgreedSalary';
import PlacementExpensesVue from './PlacementExpenses.vue';
import PlacementDocumentChecklistVue from './PlacementDocumentChecklist.vue';
import PlacementSeaContract from './PlacementSeaContract.vue';
import PlacementNorwegianContractVue from './PlacementNorwegianContract.vue';
import Contract from '../models/Contract';
import PlacementSalary from './PlacementSalary.vue';

export default {
    name: 'Placement',
    components: {
        DatePicker,
        InputField,
        Dropdown,
        TextArea,
        PlacementDocumentChecklistVue,
        PlacementContracts,
        PlacementExpensesVue,
        PlacementSeaContract,
        PlacementNorwegianContractVue,
        PlacementSalary,
    },
    data: function () {
        return {
            currentContract: new Contract({}),
            agreedSalaries: false,
            activeAgreedSalary: new AgreedSalary({}),
            pastAgreedSalary: new AgreedSalary({}),
            placement: new Placement({id: this.$route.params.id}),
            placementValidation: new Placement({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'placement-information',
            lockTimer: null,
            seniorityList: [
                {value: 1, label: '1'},
                {value: 2, label: '2'},
                {value: 3, label: '3'},
                {value: 4, label: '4'},
                {value: 5, label: '5'},
                {value: 6, label: '6'},
                {value: 7, label: '7'},
                {value: 8, label: '8'},
                {value: 9, label: '9'},
                {value: 10, label: '10'},
            ],
            maritimeObjectReadOnly: true,
            note: new PlacementNote({}),
            notesList: [],
            rankReadOnly: false,
            statusReadOnly: true,
            oldStatus: null,
            oldVacancy: null,
            tabMain: 'placement-information',
            currentTab: 'placement-information',
            tab: 'placement-information',
            activeContractId: 0,
            confirmedContractId: 0,
            statusDisplay: '',
            seafarerStatusDisplay: '',
            colorForStatus: '',
            startRank: null,
            startSeniority: null,
            seaContract: false,
            norwegianContract: false,
            contractEdit: false,
        };
    },
    watch: {
        'placement.vacancy_id': {
            handler: function () {
                let vm = this;
                if (this.placement.vacancy_id === null) {
                    vm.maritimeObjectReadOnly = false;
                    vm.rankReadOnly = false;
                }
            },
            deep: true,
        },
    },
    methods: {
        reloadPlacement() {
            let vm = this;
            this.$APICall('get', 'placements/' + this.placement.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data.item));
                    let additionalDAta = JSON.parse(JSON.stringify(data.additional));
                    vm.activeContractId = JSON.parse(JSON.stringify(data.active_contract_id));
                    vm.confirmedContractId = JSON.parse(JSON.stringify(data.confirmed_contract_id));
                    vm.statusDisplay = JSON.parse(JSON.stringify(data.status_display));
                    vm.seafarerStatusDisplay = JSON.parse(JSON.stringify(data.seafarer_status_display));
                    vm.colorForStatus = JSON.parse(JSON.stringify(data.color_for_status));
                    vm.placement = usableData;
                    vm.startRank = vm.placement.rank_id;
                    vm.startSeniority = vm.placement.seniority;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.placements'),
                            href: '/#/placements',
                            disabled: false,
                        },
                        {
                            text: additionalDAta,
                            href: '/#/placements/' + vm.placement.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                    if (vm.placement.placement_status_id == 9 || vm.placement.placement_status_id == 8) {
                        vm.generateTimesheet();
                    }
                    vm.reloadNotes();
                    vm.statusReadOnly = true;
                    vm.oldStatus = ({}, vm.placement.placement_status_id);
                    vm.oldVacancy = ({}, vm.placement.vacancy_id);
                    vm.reloadAgreedSalaries();
                }
            });
        },
        removeEdit() {
            this.inEditMode = false;
            clearInterval(this.lockTimer);
            this.$removeLock(this, this.lockKey + '|' + this.placement.id);
        },
        editForTab() {
            let vm = this;
            this.inEditMode = !this.inEditMode;
            if (this.inEditMode == false) {
                clearInterval(vm.lockTimer);
                this.$removeLock(this, this.lockKey + '|' + this.placement.id);
            } else {
                this.editClick();
            }
        },
        openSeafarer() {
            let routeData = this.$router.resolve('/seafarers/' + this.placement.seafarer_id);
            window.open(routeData.href, '_blank');
        },
        cancelPlacement() {
            let vm = this;
            this.$verify(this.$t('alerts.cancelPlacementQuestion'), (result) => {
                if (result) {
                    this.$APICall('post', 'cancel-placement/' + this.placement.id, {}, (data, succes) => {
                        if (!succes) {
                            vm.$alert(vm.$t('alerts.basicError'));
                        } else {
                            vm.$APICall('get', 'placements/' + vm.placement.id, {}, (data, success) => {
                                if (success) {
                                    let usableData = JSON.parse(JSON.stringify(data.item));
                                    let additionalDAta = JSON.parse(JSON.stringify(data.additional));
                                    vm.activeContractId = JSON.parse(JSON.stringify(data.active_contract_id));
                                    vm.confirmedContractId = JSON.parse(JSON.stringify(data.confirmed_contract_id));
                                    vm.placement = usableData;
                                    vm.$myStore.commit('setBreadcrumbs', [
                                        {
                                            text: vm.$t('modules.placements'),
                                            href: '/#/placements',
                                            disabled: false,
                                        },
                                        {
                                            text: additionalDAta,
                                            href: '/#/placements/' + vm.placement.id,
                                            disabled: true,
                                        },
                                    ]);
                                    vm.$nextTick(() => {
                                        vm.initialLoad = true;
                                    });
                                    vm.reloadNotes();
                                    vm.statusReadOnly = true;
                                    vm.oldStatus = ({}, vm.placement.placement_status_id);
                                    vm.oldVacancy = ({}, vm.placement.vacancy_id);
                                    vm.inEditMode = false;
                                    vm.reloadAgreedSalaries();
                                }
                            });
                        }
                    });
                }
            });
        },
        changeTab(id) {
            this.tabMain = this.currentTab;
            if (this.inEditMode) {
                let vm = this;
                this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                    if (result) {
                        clearInterval(vm.lockTimer);
                        this.$removeLock(this, this.lockKey + '|' + this.placement.id);
                        this.tabMain = id;
                        this.tab = id;
                        this.currentTab = id;
                        switch (this.tabMain) {
                            case 'placement-information':
                                this.lockKey = 'placement-information';
                                this.reloadPlacement();
                                break;
                            case 'document-checklist':
                                this.lockKey = 'document-checklist';
                                break;
                            case 'contracts':
                                this.lockKey = 'contracts';
                                break;
                            case 'expenses':
                                this.lockKey = 'expenses';
                                break;
                            case 'salary':
                                this.lockKey = 'salary';
                                break;
                            default:
                                break;
                        }
                        vm.inEditMode = false;
                    }
                });
            } else {
                this.tabMain = id;
                this.tab = id;
                this.currentTab = id;
                switch (this.tabMain) {
                    case 'placement-information':
                        this.lockKey = 'placement-information';
                        this.reloadPlacement();
                        break;
                    case 'document-checklist':
                        this.lockKey = 'document-checklist';
                        break;
                    case 'contracts':
                        this.lockKey = 'contracts';
                        break;
                    case 'expenses':
                        this.lockKey = 'expenses';
                        break;
                    case 'salary':
                        this.lockKey = 'salary';
                        break;
                    default:
                        break;
                }
            }
        },
        saveNote() {
            let vm = this;
            if (this.note.note == '') {
                this.$notify(vm.$t('alerts.writeNote'));
            } else {
                this.note.placement_id = this.placement.id;
                this.note.user_id = this.$myStore.state.user.id;
                this.note.timestamp = Date.now();
                this.$APICall('post', 'placement-notes', this.note, (data, succes) => {
                    if (succes) {
                        vm.reloadNotes();
                        vm.note = new PlacementNote({});
                    } else {
                        vm.$notify(vm.$t('alerts.basicError'));
                    }
                });
            }
        },
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.placement.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.placement.id);
                    }, 10000);
                    if (this.placement.vacancy_id != null) {
                        vm.maritimeObjectReadOnly = true;
                        vm.rankReadOnly = true;
                    } else {
                        vm.maritimeObjectReadOnly = false;
                        vm.rankReadOnly = false;
                    }
                    if (vm.placement.placement_status_id == 7 || vm.placement.placement_status_id == 8) {
                        vm.rankReadOnly = true;
                        vm.statusReadOnly = true;
                    } else {
                        vm.statusReadOnly = false;
                    }
                    if (vm.placement.id != 0) {
                        vm.maritimeObjectReadOnly = true;
                    }
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },
        reloadAgreedSalaries() {
            this.$APICall('get', 'agreed-salaries/' + this.placement.id, {}, (data, succes) => {
                if (succes) {
                    let vm = this;
                    vm.agreedSalaries = JSON.parse(JSON.stringify(data.has_salary));
                    if (vm.agreedSalaries) {
                        vm.activeAgreedSalary = JSON.parse(JSON.stringify(data.active));
                        vm.pastAgreedSalary = JSON.parse(JSON.stringify(data.past));
                    }
                }
            });
        },
        backClick() {
            this.$router.push('/placements');
        },
        reloadNotes() {
            let vm = this;
            this.$APICall('get', 'placement-notes/' + vm.placement.id, {}, (data, succes) => {
                if (succes) {
                    vm.notesList = data.items;
                }
            });
        },
        validateInputs(success) {
            let missingFields = '';
            if (this.placement.seafarer_id == '' || this.placement.seafarer_id == null) {
                success = false;
                this.placementValidation.seafarer_id = false;
                missingFields += this.$t('fields.seafarer') + '<br/>';
            } else {
                this.placementValidation.seafarer_id = true;
            }
            if (this.placement.maritime_object_id == '' || this.placement.maritime_object_id == null) {
                success = false;
                this.placementValidation.maritime_object_id = false;
                missingFields += this.$t('fields.maritimeObject') + '<br/>';
            } else {
                this.placementValidation.maritime_object_id = true;
            }
            if (this.placement.rank_id == '' || this.placement.rank_id == null) {
                success = false;
                this.placementValidation.rank_id = false;
                missingFields += this.$t('fields.rank') + '<br/>';
            } else {
                this.placementValidation.rank_id = true;
            }
            if (this.placement.placement_status_id == '' || this.placement.placement_status_id == null) {
                success = false;
                this.placementValidation.placement_status_id = false;
                missingFields += this.$t('fields.status') + '<br/>';
            } else {
                this.placementValidation.placement_status_id = true;
                if (this.placement.placement_status_id == 2) {
                    if (this.placement.sign_on_date == null) {
                        success = false;
                        this.placementValidation.sign_on_date = false;
                    } else {
                        this.placementValidation.sign_on_date = true;
                    }
                }
            }
            // if (this.placement.seniority == '' || this.placement.seniority == null) {
            //     success = false;
            //     this.placementValidation.seniority = false;
            //     missingFields += this.$t('fields.seniority') + '<br/>';
            // } else {
            //     this.placementValidation.seniority = true;
            // }
            if (!success) {
                let alert = 'Missing fields: <br/> ' + missingFields;
                this.$alert(alert);
            }

            return success;
        },
        closeContract() {
            this.seaContract = false;
            this.norwegianContract = false;
            this.contractEdit = false;
            this.inEditMode = false;
        },
        generateTimesheet() {
            let vm = this;
            let userId = this.$myStore.state.user.id;
            this.$APICall('get', 'generate-timesheet/' + this.placement.id, {userId}, (data, success) => {
                if (!success) {
                    vm.$alert(vm.$t('alerts.generatingTimesheetError'));
                }
            });
        },
        saveClick(goBack) {
            let success = true;
            success = this.validateInputs(success);

            if (success) {
                if (
                    (this.startRank != this.placement.rank_id || this.startSeniority != this.placement.seniority) &&
                    this.placement.placement_status_id == 9
                ) {
                    this.$verify(this.$t('alerts.changedRankSeniorityNewContractr'), (result) => {
                        if (result) {
                            let vm = this;
                            let rank = this.placement.rank_id;
                            let seniority = this.placement.seniority;
                            let date = new Date();
                            let userId = this.$myStore.state.user.id;
                            let contractType = this.activeAgreedSalary.contract_type_id;
                            this.$APICall(
                                'get',
                                'wage-template-info-rank-and-seniority/' + this.placement.id,
                                {rank, seniority},
                                (data, success) => {
                                    if (success) {
                                        if (data.response_message == 1) {
                                            vm.$APICall(
                                                'post',
                                                'create-new-contract-new-rank-seniority-contracts/' + vm.placement.id,
                                                {seniority, rank, date, contractType, userId},
                                                (data, success) => {
                                                    if (success) {
                                                        vm.currentContract = data.contract;
                                                        vm.currentContract.properties = JSON.parse(
                                                            data.contract.properties,
                                                        );
                                                        vm.contractEdit = true;
                                                        if (
                                                            vm.currentContract.contract_type_id == 1 ||
                                                            vm.currentContract.contract_type_id == 7
                                                        ) {
                                                            vm.seaContract = true;
                                                        } else {
                                                            vm.norwegianContract = true;
                                                        }
                                                    }
                                                },
                                            );
                                        } else {
                                            vm.$alert(vm.$t('alerts.defineWageTemplateForRankAndSeniority'));
                                            vm.cancelBtn();
                                        }
                                    }
                                },
                            );
                        }
                    });
                } else {
                    let vm = this;
                    let action = 'post';
                    let addition = '';
                    if (vm.placement.id != 0) {
                        action = 'put';
                        addition = '/' + vm.placement.id;
                    }
                    this.$APICall(action, 'placements' + addition, this.placement, (data, success) => {
                        if (success) {
                            vm.inEditMode = false;
                            if (data.response_message == 0) {
                                vm.$alert(vm.$t('alerts.cannotCreatePlannedPlacement'));
                            } else {
                                if (vm.placement.id == 0) {
                                    vm.$notify(vm.$t('alerts.basicAdd'));
                                } else {
                                    vm.$notify(vm.$t('alerts.basicUpdate'));
                                }
                                if (this.lockTimer !== null) clearInterval(this.lockTimer);
                                vm.$removeLock(vm, vm.lockKey + '|' + vm.placement.id);
                                if (goBack) {
                                    vm.backClick();
                                } else {
                                    vm.reloadPlacement();
                                }
                            }
                        } else {
                            vm.$alert(data && data.message ? data.message : vm.$t('alerts.placementExists'));
                        }
                    });
                }
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    let elHtml = document.getElementsByTagName('html')[0];
                    elHtml.style.overflowY = 'auto';
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    this.$removeLock(this, this.lockKey + '|' + this.placement.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            let elHtml = document.getElementsByTagName('html')[0];
            elHtml.style.overflowY = 'auto';
            next(true);
        }
    },
    beforeRouteUpdate(to, from, next) {
        // Iste rute (/placements/:id) dijele instancu komponente; pri promjeni id-a Vue reciklira
        // instancu (mounted se ne ponavlja), pa this.placement ostane zastario. Ponovno dohvati.
        if (to.params.id === from.params.id) {
            next();
            return;
        }
        if (this.lockTimer !== null) clearInterval(this.lockTimer);
        if (this.inEditMode) {
            this.$removeLock(this, this.lockKey + '|' + this.placement.id);
        }
        this.placement = new Placement({id: to.params.id});
        this.inEditMode = false;
        this.initialLoad = false;
        this.contractEdit = false;
        this.reloadPlacement();
        next();
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let elHtml = document.getElementsByTagName('html')[0];
        elHtml.style.overflowY = 'hidden';
        if (this.placement.id != 0 && this.placement.id > 0) {
            this.reloadPlacement();
        } else {
            if (this.placement.id < 0) {
                this.placement.seafarer_id = this.placement.id * -1;
                this.placement.id = 0;
            }
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.placements'),
                    href: '/#/placements',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newPlacement'),
                    href: '/#/placements/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
            this.statusReadOnly = false;
            this.rankReadOnly = false;
            this.maritimeObjectReadOnly = false;
        }
    },
};
</script>

<style scoped></style>
